/**
 * The frame each figure was last drawn in (lane QINGGONG-POSES): its image (before the fabric swap, so the cached frame
 * canvas itself) and its screen facing, noted by the renderer's frame wrapper (render/hitStop.ts `hitStopShot`, which
 * every figure's frame passes through). The afterimages (effects.ts ghosts) copy it when they are dropped, so a ghost
 * shows the pose the fighter was really in — a step, an air dash, a dive — in the view it was drawn in.
 */

interface Noted {
  img: HTMLCanvasElement;
  facing: number;
  at: number;
}

const shots = new Map<number, Noted>();

/** Notes figure `id`'s frame drawn at world time `t`. */
export function noteShot(id: number, s: { img?: HTMLCanvasElement; facing?: number }, t: number): void {
  if (!s.img) return;
  const n = shots.get(id);
  if (n) {
    n.img = s.img;
    n.facing = s.facing ?? 1;
    n.at = t;
  } else shots.set(id, { img: s.img, facing: s.facing ?? 1, at: t });
  if (shots.size > 512) for (const [k, v] of shots) if (t - v.at > 1) shots.delete(k);
}

/** Figure `id`'s last drawn frame, if it was drawn within the last tenth of a second of `t` (else null). */
export function lastShotOf(id: number, t: number): { img: HTMLCanvasElement; facing: number } | null {
  const n = shots.get(id);
  return n && t - n.at <= 0.1 && n.at <= t + 1e-6 ? n : null;
}
